
    import { css } from 'lit-element';
    export default css`:host{display:flex;flex-direction:column}`;
  